import { combineReducers } from "redux";
import {UserProfile,UserContract,MakeChannel} from "./Reducer";
const Reducers = combineReducers({
  UserProfile,UserContract,MakeChannel
  });

  
  export default Reducers;